import { FC, useEffect, useState } from "react";
import { appInsights, reactPlugin, withAITracking } from "../../../appInsights";
import { Row, Col } from "antd";
import Vitals from "../overview/vitals";
import Labs from "../overview/labs";
import Icon from "@assets/icon_config";
import membersService from "@services/members.service";
import { centricClientCheck } from "@utils/helpers";

const EHR: FC<any> = (props) => {
  const isCentric = centricClientCheck();
  const defaultExpandedCards = isCentric ? ["38"] : ["2"];
  const expandAllCards = ["2", "38"];
  const patientId = membersService?.getCurrentMember?.patient_id;

  const [activePanels, setActivePanels] = useState<any>(defaultExpandedCards);

  useEffect(() => {
    console.log("EHR.useEffect");
    appInsights.trackPageView({ name: "EHR Data" });
  }, []);

  useEffect(() => {
    setActivePanels(defaultExpandedCards);
  },[patientId])

  const changeCollapse = () => {
    if(activePanels?.length > 0) {
      setActivePanels([])
    } else {
      setActivePanels(expandAllCards)
    }
  }

  return (
    <>
      {process.env.REACT_APP_SHOW_LABS_VITALS === "true" && (
        <>
          <div className="member-detail-tab-header">
            <div className="member-detail-tab-header__collapse-all-button" onClick={changeCollapse}>
              <span className="member-detail-tab-header__collapse-all-button__title">{activePanels?.length > 0 ? "Collapse All" : "Expand All"} </span>
              <span className={`member-detail-tab-header__collapse-all-button__arrow ${activePanels?.length > 0 ? "" : "arrow-down"}`}>
                <Icon name={`${activePanels?.length > 0 ? "arrowUp" : "arrowDown"}`} colorOfBrand={"#0072E3"} />
              </span>
            </div>
          </div>
          <Row>
            <Col span={24}>
              {!isCentric && <Vitals pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds} activeKey={activePanels} setActivePanels={setActivePanels} />}
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Labs pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds} activeKey={activePanels} setActivePanels={setActivePanels} />
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default withAITracking(reactPlugin, EHR);
